import { apiFields } from "./_utils";
import * as classwizeConfigApi from "js/api/classwizeConfigApi";

export const createClasswizeConfigStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {},

	fetch: async () => {
		setIn((state) => ({ isFetching: !state.isFetching }));
		const data = await classwizeConfigApi.getClasswizeConfig();
		setIn({ data, isFetching: false, lastFetched: Date.now() });
	},
});

export const isMembershipOwnershipDisabled = (state) => {
	if (
		!state.classwizeConfig.data.hasOwnProperty("classroom_restrict_global_teachers") ||
		!state.classwizeConfig.data.hasOwnProperty("classroom_allow_owner_access")
	) {
		return false;
	}

	return !state.classwizeConfig.data.classroom_restrict_global_teachers && !state.classwizeConfig.data.classroom_allow_owner_access;
};

export const isMembershipOnly = (state) => {
	if (
		!state.classwizeConfig.data.hasOwnProperty("classroom_restrict_global_teachers") ||
		!state.classwizeConfig.data.hasOwnProperty("classroom_allow_owner_access")
	) {
		return false;
	}

	return state.classwizeConfig.data.classroom_restrict_global_teachers && !state.classwizeConfig.data.classroom_allow_owner_access;
};

/* eslint-disable camelcase */
export const getSupportContactDetails = (state) => ({
	enable_support_chatbot: state.classwizeConfig.data.enable_support_chatbot,
	support_chatbot_contact_email: state.classwizeConfig.data.support_chatbot_contact_email,
	support_chatbot_contact_name: state.classwizeConfig.data.support_chatbot_contact_name,
	support_chatbot_id: state.classwizeConfig.data.support_chatbot_id,
	support_contact_email: state.classwizeConfig.data.support_contact_email,
	support_contact_name: state.classwizeConfig.data.support_contact_name,
	support_contact_phone: state.classwizeConfig.data.support_contact_phone,
	support_message: state.classwizeConfig.data.support_message,
});
/* eslint-enable camelcase */

/**
 * @param {ClasswizeState} state
 * @returns {string[]} Array of Classwise features enabled
 */
export const getFeatures = (state) => state.classwizeConfig.data.classroom_features_enabled;

export const isSupportContactDetailsLoaded = (state) => {
	for (const [key, value] of Object.entries(state.classwizeConfig.data)) {
		if (key === "support_message") continue;
		if (value) {
			return true;
		}
	}

	return false;
};

export const getClasswizeConfig = (state) => state.classwizeConfig.data;
